var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "gtpReportModal",
            size: "lg",
            "content-class": "menu-bg-blue-transparent-modal gtp-rpt-modal",
            title: "Ground Truth Point Report",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.getGTPReport()
            },
          },
        },
        [
          _c("vue-bootstrap4-table", {
            attrs: {
              rows: _vm.gtpRows,
              columns: _vm.gtpColumns,
              config: _vm.config,
              classes: _vm.classes,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }